
// utils.js
import axios from "axios";
import { Subject } from "../utils/observable/observable";
import { auth0Client } from "./auth0Client";
import { deleteDeviceToken } from "../utils/deviceTokenDelete";

let is429ToastShown = false;
let globalSetToastStatus = null;
export const authEvents$ = new Subject(); 
const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''

// Call this once in App.js to pass the setToastStatus function
export const registerToastSetter = (setterFunc) => {
  globalSetToastStatus = setterFunc;
};

const invalidateSession = async() => {
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}users/${userId}/sessions/invalidate`, {}, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}})

    } catch(error) {
      console.log("invalidateSession error ",error)
    }
}

const logoutAfterTokenExpired = async() => {
    try {
      console.log("localStorage.getItem('token') ",localStorage.getItem('token'))
      await axios.get(`${process.env.REACT_APP_BASE_URL}oauth/logout`, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}})

    } catch(error) {
      console.log("logoutAfterTokenExpired error ",error)
    }
}

export const ApiService = () => {
  const instance = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_BASE_URL,
  });

  // Request Interceptor → attach fresh token from Auth0
  instance.interceptors.request.use(
    async (config) => {
      try {
        const token = await auth0Client.getAccessTokenSilently();
        localStorage.setItem('token',token)
        config.headers.Authorization = `Bearer ${token}`;
      } catch (err) {
        console.error("Failed to get token:", err?.message);
        throw err;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => response,
    async (error) => {

      if (error.response?.status === 429 && !is429ToastShown && globalSetToastStatus) {
        is429ToastShown = true;
        globalSetToastStatus({
          color: "red",
          status: true,
          message: "Too many requests. Please try again after 30 seconds.",
          icon: "close",
        });

        setTimeout(() => {
          globalSetToastStatus({ color: "", status: false, message: "" });
          is429ToastShown = false;
        }, 4000);
      }
      if (error.response?.status === 403 || error.response?.status === 401) {
        console.warn("403 detected — logging out");
        authEvents$.next({ type: '401' });
        setTimeout(async() => {
          await deleteDeviceToken()
          await invalidateSession()
          await logoutAfterTokenExpired()
          localStorage.clear()
          localStorage.setItem('logout',true)
          console.log("windindwinwd ",window.location.origin)
          auth0Client.logout({ logoutParams: { returnTo: window.location.origin } })
        },5000)
      } else if(error?.message === "Unknown or invalid refresh token.") {
        console.warn("403 detected — logging out");
        authEvents$.next({ type: '401' });
        setTimeout(async() => {
          await deleteDeviceToken()
          await invalidateSession()
          await logoutAfterTokenExpired()
          localStorage.clear()
          localStorage.setItem('logout',true)
          console.log("windindwinwd ",window.location.origin)
          auth0Client.logout({ logoutParams: { returnTo: window.location.origin } })
        },5000)
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
